import { render, staticRenderFns } from "./FieldLabel.vue?vue&type=template&id=349f2e19"
import script from "./FieldLabel.vue?vue&type=script&lang=js"
export * from "./FieldLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports